import PropTypes from 'prop-types';

import { constants } from '@eb/event-create-publish-utils';
import { lazyGettext } from '@eb/lazy-gettext';
import { translationPropType } from '@eb/i18n';

const {
    DISPLAY_SALES_STATUS_ON_SALE,
    DISPLAY_SALES_STATUS_SALES_ENDED,
    DISPLAY_SALES_STATUS_SOLD_OUT,
    EVENT_TEXT_CODE_TICKETS_SOLD_OUT_KEY,
    DISPLAY_SALES_STATUS_NOT_YET_ON_SALE_ACCESS_CODED,
    DISPLAY_SALES_STATUS_TICKETS_ATD,
    DISPLAY_SALES_STATUS_CANCELLED,
    DISPLAY_SALES_STATUS_POSTPONED,
} = constants;

export const FORM_NAME = 'salesStatus';

export const DATE_MONTH_DAY_FORMAT = 'MMM DD';
export const DATE_TIME_FORMAT = 'h:mm A';

export const CUSTOM_MESSAGE_MAX_LENGTH = 48;

export const SALES_STATUS_DEFAULT_OPTIONS = [
    {
        display: lazyGettext('Tickets At The Door'),
        value: DISPLAY_SALES_STATUS_TICKETS_ATD,
    },
    {
        display: lazyGettext('Sold Out'),
        value: EVENT_TEXT_CODE_TICKETS_SOLD_OUT_KEY,
    },
    {
        display: lazyGettext('Canceled'),
        value: DISPLAY_SALES_STATUS_CANCELLED,
    },
    {
        display: lazyGettext('Postponed'),
        value: DISPLAY_SALES_STATUS_POSTPONED,
    },
];

export const SALES_STATUS_SETTINGS_OPTIONS = [
    DISPLAY_SALES_STATUS_TICKETS_ATD,
    DISPLAY_SALES_STATUS_SOLD_OUT,
    DISPLAY_SALES_STATUS_CANCELLED,
    DISPLAY_SALES_STATUS_POSTPONED,
];

export const SALES_STATUS_ON_SALE_OPTION = {
    display: lazyGettext('On Sale'),
    value: DISPLAY_SALES_STATUS_ON_SALE,
};

export const SALES_STATUS_NOT_YET_ON_SALE_ACCESS_CODED_OPTION = {
    display: lazyGettext('On Sale Soon'),
    value: DISPLAY_SALES_STATUS_NOT_YET_ON_SALE_ACCESS_CODED,
};

export const SALES_STATUS_SALES_ENDED_OPTION = {
    display: lazyGettext('Sales Ended'),
    value: DISPLAY_SALES_STATUS_SALES_ENDED,
};

export const LOCALIZED_TEXT = {
    headline: lazyGettext('Change Status'),
    description: lazyGettext(
        'Choose a status for your event. This status affects your tickets wherever they are sold online.',
    ),
    selectorLabel: lazyGettext('Status'),
    selectorPlaceholder: lazyGettext('Choose a status...'),
    selectorPlaceholderUnavailable: lazyGettext('Unavailable'),
    customOptionLabelOnSale: lazyGettext('Off Sale — Custom'),
    customOptionLabelScheduled: lazyGettext('Custom'),
    customMessageLabel: lazyGettext('Custom Text'),
    warningNotificationTextOnSale: lazyGettext(
        'This status ends online tickets sales',
    ),
    warningNotificationTextScheduled: lazyGettext(
        "This won't affect your on sale schedule",
    ),
    modalOnSaleConfirmLabel: lazyGettext('Take Off Sale'),
    modalNotOnSaleConfirmLabel: lazyGettext('Confirm'),
    modalCancelLabel: lazyGettext('Cancel'),
    warningNotificationTextChangingStatusDisabled: lazyGettext(
        "You can't override the event status because the status is unavailable or the waiting room is enabled.",
    ),
};

export const DISPLAY_SALES_STATUS_TO_WARNING_NOTIFICATION_TEXT_MAP = {
    [DISPLAY_SALES_STATUS_CANCELLED]: lazyGettext(
        "This status ends online ticket sales. Remember to delete your event reminders, email your attendees and adjust your refund policy, especially if you've already refunded buyers outside of Eventbrite.",
    ),
    [DISPLAY_SALES_STATUS_POSTPONED]: lazyGettext(
        'This status ends ticket sales. You should email your attendees and consider issuing refunds.',
    ),
};

export const REDIRECT_TO_EMAIL = lazyGettext("We'll take you to emails next.");

export const FIELD_NAMES = {
    customMessage: 'customMessage',
    statusCode: 'statusCode',
};

export const STATUS_OPTION_PROP_TYPE = PropTypes.shape({
    display: translationPropType,
    value: PropTypes.string,
});
